import paths from 'routing/routes/_paths';

import VesselSituations from 'views/enums/vessels/situations';
import VesselPrefixes from 'views/enums/vessels/prefixes';
import WidgetTypes from 'views/enums/widget-types';
import CharterPartiesForms from 'views/enums/cp-forms';
import Ports from 'views/enums/ports';
import ClassificationSocieties from 'views/enums/classification-societies';
import Airports from 'views/enums/airports';
import RoutingAreas from 'views/enums/routing-areas';
import FuelGrades from 'views/enums/fuel-grades';
import CrewIdentifiers from 'views/enums/crew-identifiers';
import CrewStatuses from 'views/enums/crew-statuses';
import Airlines from 'views/enums/airlines';
import CrewRank from 'views/enums/crew-rank';
import Units from 'views/enums/units';
import AgentTypes from 'views/enums/agent-types';
import Countries from 'views/enums/countries';
import Nationalities from 'views/enums/nationalities';
import Currencies from 'views/enums/currencies';
import Tools from 'views/enums/tools';
import LaytimeEvents from 'views/enums/laytime-events';
import LdTerms from 'views/enums/ld-terms';
import CrewMatrix from 'views/enums/crew-matrix';
import EventTypes from 'views/enums/event-types';
import PurchasingGroup from 'views/enums/purchasing-groups';
import PurchasingStores from 'views/enums/purchasing-stores';
import retry from '@/common/utils/lazy-retry';
import React from 'react';

const VesselTypes = React.lazy(() => retry(() => import('@/views/enums/vessel-types/index.tsx')));
const VesselTypeCategories = React.lazy(() =>
  retry(() => import('@/views/enums/vessel-types/categories/index.tsx'))
);
const VesselSubTypes = React.lazy(() =>
  retry(() => import('@/views/enums/vessel-types/vessel-subtypes/index.jsx'))
);

const Cargos = React.lazy(() => retry(() => import('@/views/enums/cargos/index.tsx')));

const routes = [
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.airports,
    component: Airports,
    documentTitle: 'Enums | Airports'
  },

  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.airlines,
    component: Airlines,
    documentTitle: 'Enums | Airlines'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.cargo,
    component: Cargos,
    documentTitle: 'Enums | Cargos'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.ports,
    component: Ports,
    documentTitle: 'Enums | Ports'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.ports_map,
    component: Ports,
    documentTitle: 'Enums | Ports'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.classification_societies,
    component: ClassificationSocieties,
    documentTitle: 'Enums | Classification Societies'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.cp_forms,
    component: CharterPartiesForms,
    documentTitle: 'Enums | Charter Parties Forms'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.fuel_grades,
    component: FuelGrades,
    documentTitle: 'Enums | Fuel Grades'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.widget_types,
    component: WidgetTypes,
    documentTitle: 'Enums | Widget Types'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.vessel_prefixes,
    component: VesselPrefixes,
    documentTitle: 'Enums | Vessel Prefixes'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.vessel_situations,
    component: VesselSituations,
    documentTitle: 'Enums | Vessel Situations'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.routing_areas,
    component: RoutingAreas,
    documentTitle: 'Enums | Routing Areas'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.crew_statuses,
    component: CrewStatuses,
    documentTitle: 'Enums | Crew Statuses'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.crew_identifiers,
    component: CrewIdentifiers,
    documentTitle: 'Enums | Crew Identifiers'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.vessel_types,
    component: VesselTypes,
    documentTitle: 'Enums | Vessel Types'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.vessel_subtypes,
    component: VesselSubTypes,
    documentTitle: 'Enums | Vessel Sub-types'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.vessel_type_categories,
    component: VesselTypeCategories,
    documentTitle: 'Enums | Vessel Type Categories'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.crew_rank,
    component: CrewRank,
    documentTitle: 'Enums | Crew Ranks'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.countries,
    component: Countries,
    documentTitle: 'Enums | Countries'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.nationalities,
    component: Nationalities,
    documentTitle: 'Enums | Nationalities'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.currencies,
    component: Currencies,
    documentTitle: 'Enums | Currencies'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.agent_types,
    component: AgentTypes,
    documentTitle: 'Enums | Agent Types'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.units,
    component: Units,
    documentTitle: 'Enums | Units'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.tools,
    component: Tools,
    documentTitle: 'Enums | Tools'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.laytime_events,
    component: LaytimeEvents,
    documentTitle: 'Enums | Laytime Events'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.ld_terms,
    component: LdTerms,
    documentTitle: 'Enums | Ld Terms'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.crew_matrices,
    component: CrewMatrix,
    documentTitle: 'Enums | Crew Matrix'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.purchasing_groups,
    component: PurchasingGroup,
    documentTitle: 'Enums | Purchasing Groups'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.event_types,
    component: EventTypes,
    documentTitle: 'Enums | Event Types'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.enums.purchasing_stores,
    component: PurchasingStores,
    documentTitle: 'Enums | Purchasing Stores'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: `${paths.enums.purchasing_stores_unlinked}/:organizationId?`,
    component: PurchasingStores,
    documentTitle: 'Enums | Purchasing Stores'
  }
];

export default routes;
